<template>
  <div class="practice-product-card" :class="{ 'inactive-card': product.status !== 'active' }">
    <!-- Image Area -->
    <div class="card-image-area">
      <div v-if="!imageSrc" class="placeholder-image" :class="product.status === 'active' ? 'active-bg' : 'inactive-bg'">
        <!-- Active: colored logo -->
        <svg v-if="product.status === 'active'" xmlns="http://www.w3.org/2000/svg" width="54" height="49" viewBox="0 0 54 49" fill="none">
          <path d="M39.3183 32.7161C42.398 32.7161 44.8945 30.252 44.8945 27.2125C44.8945 24.173 42.398 21.709 39.3183 21.709C36.2387 21.709 33.7422 24.173 33.7422 27.2125C33.7422 30.252 36.2387 32.7161 39.3183 32.7161Z" fill="#8BBDC7"/>
          <path d="M8.13304 17.8511C12.6248 17.8511 16.2661 14.2573 16.2661 9.824C16.2661 5.39074 12.6248 1.79688 8.13304 1.79688C3.64128 1.79688 0 5.39074 0 9.824C0 14.2573 3.64128 17.8511 8.13304 17.8511Z" fill="#1E4670"/>
          <path d="M45.1018 17.8511C49.5935 17.8511 53.2348 14.2573 53.2348 9.824C53.2348 5.39074 49.5935 1.79688 45.1018 1.79688C40.61 1.79688 36.9688 5.39074 36.9688 9.824C36.9688 14.2573 40.61 17.8511 45.1018 17.8511Z" fill="#1E4670"/>
          <path d="M26.4885 48.5035C30.9803 48.5035 34.6215 44.9096 34.6215 40.4763C34.6215 36.0431 30.9803 32.4492 26.4885 32.4492C21.9968 32.4492 18.3555 36.0431 18.3555 40.4763C18.3555 44.9096 21.9968 48.5035 26.4885 48.5035Z" fill="#1E4670"/>
          <path d="M15.9293 7.53084C15.9293 7.53084 18.5112 16.0341 26.4968 16.0341C34.9947 16.0341 37.3192 7.52344 37.3192 7.52344L43.3177 17.6572C43.3177 17.6572 34.03 15.3828 30.0134 22.2777C25.9969 29.1725 31.718 34.3282 31.718 34.3282H21.2631C21.2631 34.3282 26.5118 28.6545 22.9826 22.2777C19.0361 15.1707 10.6406 17.4722 10.6406 17.4722L15.9293 7.53084Z" fill="#1E4670"/>
          <path d="M26.6191 11.0071C29.6987 11.0071 32.1953 8.54306 32.1953 5.50354C32.1953 2.46402 29.6987 0 26.6191 0C23.5395 0 21.043 2.46402 21.043 5.50354C21.043 8.54306 23.5395 11.0071 26.6191 11.0071Z" fill="#8BBDC7"/>
          <path d="M13.709 32.7161C16.7886 32.7161 19.2851 30.252 19.2851 27.2125C19.2851 24.173 16.7886 21.709 13.709 21.709C10.6293 21.709 8.13281 24.173 8.13281 27.2125C8.13281 30.252 10.6293 32.7161 13.709 32.7161Z" fill="#8BBDC7"/>
        </svg>
        <!-- Inactive: grey logo -->
        <svg v-else xmlns="http://www.w3.org/2000/svg" width="54" height="49" viewBox="0 0 54 49" fill="none">
          <path d="M39.3183 32.7161C42.398 32.7161 44.8945 30.252 44.8945 27.2125C44.8945 24.173 42.398 21.709 39.3183 21.709C36.2387 21.709 33.7422 24.173 33.7422 27.2125C33.7422 30.252 36.2387 32.7161 39.3183 32.7161Z" fill="#C4C4C4"/>
          <path d="M8.13304 17.8511C12.6248 17.8511 16.2661 14.2573 16.2661 9.824C16.2661 5.39074 12.6248 1.79688 8.13304 1.79688C3.64128 1.79688 0 5.39074 0 9.824C0 14.2573 3.64128 17.8511 8.13304 17.8511Z" fill="#9A9A9A"/>
          <path d="M45.1018 17.8511C49.5935 17.8511 53.2348 14.2573 53.2348 9.824C53.2348 5.39074 49.5935 1.79688 45.1018 1.79688C40.61 1.79688 36.9688 5.39074 36.9688 9.824C36.9688 14.2573 40.61 17.8511 45.1018 17.8511Z" fill="#9A9A9A"/>
          <path d="M26.4885 48.5035C30.9803 48.5035 34.6215 44.9096 34.6215 40.4763C34.6215 36.0431 30.9803 32.4492 26.4885 32.4492C21.9968 32.4492 18.3555 36.0431 18.3555 40.4763C18.3555 44.9096 21.9968 48.5035 26.4885 48.5035Z" fill="#9A9A9A"/>
          <path d="M15.9293 7.53084C15.9293 7.53084 18.5112 16.0341 26.4968 16.0341C34.9947 16.0341 37.3192 7.52344 37.3192 7.52344L43.3177 17.6572C43.3177 17.6572 34.03 15.3828 30.0134 22.2777C25.9969 29.1725 31.718 34.3282 31.718 34.3282H21.2631C21.2631 34.3282 26.5118 28.6545 22.9826 22.2777C19.0361 15.1707 10.6406 17.4722 10.6406 17.4722L15.9293 7.53084Z" fill="#9A9A9A"/>
          <path d="M26.6191 11.0071C29.6987 11.0071 32.1953 8.54306 32.1953 5.50354C32.1953 2.46402 29.6987 0 26.6191 0C23.5395 0 21.043 2.46402 21.043 5.50354C21.043 8.54306 23.5395 11.0071 26.6191 11.0071Z" fill="#C4C4C4"/>
          <path d="M13.709 32.7161C16.7886 32.7161 19.2851 30.252 19.2851 27.2125C19.2851 24.173 16.7886 21.709 13.709 21.709C10.6293 21.709 8.13281 24.173 8.13281 27.2125C8.13281 30.252 10.6293 32.7161 13.709 32.7161Z" fill="#C4C4C4"/>
        </svg>
      </div>
      <div v-else class="product-image">
        <img :src="imageSrc" :alt="product.name" />
        <div v-if="product.status !== 'active'" class="image-overlay"></div>
      </div>

      <!-- Status Toggle -->
      <div class="status-toggle">
        <span class="status-label inactive-label">Inactive</span>
        <div class="toggle-switch" :class="{ 'active': product.status === 'active' }" @click="toggleStatus">
          <div class="toggle-track">
            <div class="toggle-thumb"></div>
          </div>
        </div>
        <span class="status-label active-label">Active</span>
      </div>
    </div>

    <!-- Card Content -->
    <div class="card-content">
      <!-- Title Row with Actions -->
      <div class="card-title-row">
        <h3 class="card-title">{{ product.name }}</h3>
        <div class="card-actions">
          <button class="action-icon-btn edit-icon" @click="$emit('edit-product', product)">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7474 2.63813C15.9076 2.88072 15.8809 3.2104 15.6674 3.42396L8.00704 11.0843C7.92852 11.1628 7.83049 11.219 7.72305 11.2471L4.53269 12.0804C4.42864 12.1076 4.32138 12.107 4.2206 12.0814C4.11347 12.0541 4.01366 11.9985 3.93281 11.9176C3.77591 11.7607 3.71396 11.5324 3.77004 11.3177L4.60337 8.12737C4.62793 8.03336 4.67401 7.94051 4.73775 7.86768L12.4265 0.183058C12.4938 0.115755 12.5748 0.0653835 12.6631 0.0346927C12.7285 0.0119369 12.7978 0 12.8684 0C13.0342 0 13.1931 0.0658479 13.3103 0.183058L15.6674 2.54008C15.6979 2.57059 15.7246 2.60347 15.7474 2.63813ZM14.3415 2.98202L12.8684 1.50888L5.76993 8.60735L5.24911 10.6013L7.24308 10.0805L14.3415 2.98202Z" fill="#374957"/>
              <path d="M14.2362 12.4253C14.464 10.4772 14.5365 8.51565 14.4537 6.55899C14.4497 6.46531 14.4849 6.37415 14.5512 6.30785L15.3707 5.48841C15.4714 5.38766 15.6436 5.45162 15.653 5.59378C15.8071 7.91849 15.7487 10.2538 15.4777 12.5705C15.2806 14.2559 13.927 15.5767 12.2503 15.7641C9.36146 16.087 6.37535 16.087 3.48654 15.7641C1.80982 15.5767 0.456214 14.2559 0.259086 12.5705C-0.0863621 9.61689 -0.0863621 6.63311 0.259086 3.67952C0.456214 1.99408 1.80983 0.673241 3.48654 0.485843C5.678 0.240916 7.92545 0.18179 10.1439 0.308468C10.2869 0.316632 10.3521 0.489646 10.2508 0.590911L9.42371 1.41804C9.35813 1.48362 9.2682 1.51884 9.17551 1.51571C7.32016 1.45314 5.45219 1.52394 3.62538 1.72811C2.51696 1.85199 1.62905 2.72667 1.50062 3.82473C1.16646 6.68184 1.16646 9.56816 1.50062 12.4253C1.62905 13.5233 2.51696 14.398 3.62538 14.5219C6.42192 14.8344 9.3149 14.8344 12.1114 14.5219C13.2199 14.398 14.1078 13.5233 14.2362 12.4253Z" fill="#374957"/>
            </svg>
          </button>
          <button class="action-icon-btn delete-icon" @click="$emit('delete-product', product)">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0V1H16V3H15V16C15 17.1 14.1 18 13 18H3C1.9 18 1 17.1 1 16V3H0V1H5V0H11ZM3 16H13V3H3V16ZM5 5H7V14H5V5ZM11 5H9V14H11V5Z" fill="#D10000"/>
            </svg>
          </button>
        </div>
      </div>

      <!-- Description -->
      <p class="card-description">{{ product.description || "Currently we don't have product description..." }}</p>

      <!-- Details Rows -->
      <div class="card-details">
        <div class="detail-row">
          <span class="detail-key">Price</span>
          <span class="detail-value">{{ product.price }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-key">Type</span>
          <span class="detail-value">{{ capitalizeFirst(product.type) }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-key">Refund Days</span>
          <span class="detail-value">{{ product.returnDays || 'No' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-key">Refund Policy</span>
          <span class="detail-value">{{ product.refundPolicy || 'No' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-key">Revenue YTD</span>
          <span class="detail-value">{{ revenueYtd }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-key">Sold YTD</span>
          <span class="detail-value">{{ soldYtdDisplay }}</span>
        </div>
        <div v-if="showAssignees" class="detail-row">
          <span class="detail-key">Assignees</span>
          <span class="detail-value assignees-value">
            {{ assigneesCount }}
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="14" viewBox="0 0 19 14" fill="none">
              <path d="M11.6667 6.66667C13.5083 6.66667 15 5.175 15 3.33333C15 1.49167 13.5083 0 11.6667 0C9.825 0 8.33333 1.49167 8.33333 3.33333C8.33333 5.175 9.825 6.66667 11.6667 6.66667ZM11.6667 1.66667C12.5833 1.66667 13.3333 2.41667 13.3333 3.33333C13.3333 4.25 12.5833 5 11.6667 5C10.75 5 10 4.25 10 3.33333C10 2.41667 10.75 1.66667 11.6667 1.66667ZM11.6667 8.33333C9.44167 8.33333 5 9.45 5 11.6667V13.3333H18.3333V11.6667C18.3333 9.45 13.8917 8.33333 11.6667 8.33333ZM6.66667 11.6667C6.85 11.0667 9.425 10 11.6667 10C13.9167 10 16.5 11.075 16.6667 11.6667H6.66667ZM4.16667 9.16667V6.66667H6.66667V5H4.16667V2.5H2.5V5H0V6.66667H2.5V9.16667H4.16667Z" fill="#374957"/>
            </svg>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { downloadFile } from '@/api/markup';

export default {
  name: 'PracticeProductCard',
  props: {
    product: {
      type: Object,
      required: true,
    },
    currencySymbol: {
      type: String,
      default: '$',
    },
    showAssignees: {
      type: Boolean,
      default: true,
    },
    soldInfo: {
      type: Object,
      default: null,
    },
  },
  emits: ['toggle-status', 'delete-product', 'edit-product'],
  data() {
    return {
      imageSrc: null,
    };
  },
  computed: {
    revenueYtd() {
      if (this.soldInfo && this.soldInfo.revenueYtd != null) {
        return `${this.currencySymbol}${this.soldInfo.revenueYtd.toFixed(2)}`;
      }
      return `${this.currencySymbol}0.00`;
    },
    soldYtdDisplay() {
      if (this.soldInfo && this.soldInfo.soldAmountYtd != null) {
        return this.soldInfo.soldAmountYtd;
      }
      return 0;
    },
    assigneesCount() {
      // Note: API returns apply_to_all_providers, not isAll
      // isAll = apply_to_all_providers (per VA Portal dataFomatter)
      if (!this.product.providerList) return 0;
      if (this.product.apply_to_all_providers) return 'All';
      if (this.product.apply_to_self) return 'Only me';
      return this.product.providerList.length;
    },
  },
  watch: {
    'product.image': {
      async handler(newVal) {
        if (!newVal) {
          this.imageSrc = null;
          return;
        }
        await this.getImageSrc();
      },
    },
  },
  async mounted() {
    if (this.product && this.product.image) {
      await this.getImageSrc();
    }
  },
  methods: {
    capitalizeFirst(str) {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    toggleStatus() {
      const action = this.product.status === 'active' ? 'deactivate' : 'activate';
      this.$emit('toggle-status', this.product.index, action);
    },
    async getImageSrc() {
      if (!this.product.image) return;
      try {
        const parts = this.product.image.split('/');
        const folderName = parts[0];
        const fileName = parts[parts.length - 1];
        const { data } = await downloadFile(folderName, fileName);
        this.imageSrc = URL.createObjectURL(data);
      } catch (error) {
        this.imageSrc = null;
      }
    },
  },
};
</script>

<style scoped>
.practice-product-card {
  border-radius: 8px;
  border: 1px solid var(--color-Grey-Grey-E8, #E0E0E0);
  background: var(--color-White-000, #FFF);
  box-shadow: 0 1px 15px 0 rgba(164, 164, 164, 0.25);
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  overflow: hidden;
}

.inactive-card {
  border: 1px solid transparent;
  background: var(--Cool-White, #F9FBFD);
}

/* Image Area */
.card-image-area {
  position: relative;
  height: 134px;
  width: 100%;
  border-radius: 5px;
  overflow: hidden;
}

.placeholder-image {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
}

.placeholder-image.active-bg {
  background: var(--Cool-White, #F9FBFD);
}

.placeholder-image.inactive-bg {
  background: var(--Grey-White, #F2F2F2);
}

.product-image {
  width: 100%;
  height: 100%;
  position: relative;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}

.image-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 5px;
  pointer-events: none;
}

/* Status Toggle */
.status-toggle {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(249, 251, 253, 0.90);
  border-radius: 8px;
  padding: 3px 6px;
  height: 28px;
}

.status-label {
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.4px;
}

.inactive-label {
  color: var(--TrueBlack, #333);
}

.active-label {
  color: var(--TrueBlack, #333);
}

.toggle-switch {
  width: 40px;
  height: 22px;
  cursor: pointer;
}

.toggle-track {
  width: 100%;
  height: 100%;
  border-radius: 11px;
  background: #E3E5E8;
  position: relative;
  transition: background 0.2s;
}

.toggle-switch.active .toggle-track {
  background: var(--IconGrey, #374957);
}

.toggle-thumb {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #FFF;
  position: absolute;
  top: 2px;
  left: 2px;
  transition: left 0.2s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
}

.toggle-switch.active .toggle-thumb {
  left: 20px;
  background: linear-gradient(90deg, #E6EDF2 0%, #EAF8F9 100%);
}

/* Card Content */
.card-content {
  padding: 4px 8px 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  align-self: stretch;
}

.card-title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
  gap: 4px;
  align-self: stretch;
}

.card-title {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: var(--TrueBlack, #333);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  flex: 1 0 0;
  margin: 0;
}

.card-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.action-icon-btn {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
  padding: 0;
  border-radius: 4px;
}

.action-icon-btn:hover {
  background: #F0F0F0;
}

/* Description */
.card-description {
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--color-Grey-Grey-97, #979797);
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  align-self: stretch;
}

/* Detail Rows */
.card-details {
  display: flex;
  padding-top: 8px;
  margin-top: 4px;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  align-self: stretch;
  border-top: 1px solid var(--color-Grey-Grey-E8, #E0E0E0);
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 24px;
  align-self: stretch;
}

.detail-key {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: var(--SecondaryBlack, #666);
}

.detail-value {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: var(--SecondaryBlack, #666);
}

.assignees-value {
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>
